import { plural } from '@cian/utils';
import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { trackVacancyClick } from './tracking';
import { generateVacanciesLink } from './utils/generateVacanciesLink';
import { VacancyItemContainer } from '../VacancyItemContainer';
import { Vacancies } from 'shared/components/Vacancies/Vacancies';
import { selectCompanyName, selectTrackingProducts, selectVacancies } from 'shared/slices';

export const VacanciesContainer = () => {
  const { totalCount } = useSelector(selectVacancies, shallowEqual);
  const name = useSelector(selectCompanyName);
  const products = useSelector(selectTrackingProducts);

  const totalCountText = React.useMemo(
    () => (totalCount ? `Смотреть ${totalCount} ${plural(totalCount, ['вакансию', 'вакансии', 'вакансий'])}` : ''),
    [totalCount],
  );

  const vacancyLink = React.useMemo(() => (name ? generateVacanciesLink(name) : ''), [name]);

  const handleVacancyClick = React.useCallback(() => {
    trackVacancyClick(products);
  }, [products]);

  return (
    <Vacancies
      totalCount={totalCount}
      totalCountText={totalCountText}
      vacancyLink={vacancyLink}
      vacancy={<VacancyItemContainer />}
      onVacancyClick={handleVacancyClick}
    />
  );
};
